import React from "react";
import {
  BeakerIcon,
  ClockIcon,
  ArchiveBoxIcon,
  DocumentTextIcon,
  LinkIcon,
  DeviceTabletIcon,
} from "@heroicons/react/24/outline";

const PreAnalyticalControls = () => {
  const sections = [
    {
      title: "Collection & Processing",
      items: [
        {
          icon: <ClockIcon className="w-6 h-6" />,
          label: "Ischemia Control",
          description: "Documented time from collection to stabilization.",
        },
        {
          icon: <BeakerIcon className="w-6 h-6" />,
          label: "Validated Aliquoting",
          description:
            "Certified DNase/RNase-free vessels in sterile environments.",
        },
        {
          icon: <ArchiveBoxIcon className="w-6 h-6" />,
          label: "Storage Integrity",
          description: "Immediate transfer to validated -80°C or LN2 storage.",
        },
      ],
    },
    {
      title: "Documentation Provided",
      items: [
        {
          icon: <DocumentTextIcon className="w-6 h-6" />,
          label: "Certificate of Analysis",
          description:
            "Detailed processing logs and quality verification results.",
        },
        {
          icon: <LinkIcon className="w-6 h-6" />,
          label: "Chain of Custody",
          description:
            "Complete tracking from donor site to final destination.",
        },
        {
          icon: <DeviceTabletIcon className="w-6 h-6" />,
          label: "Temperature Logs",
          description:
            "Continuous monitoring data for the entire storage lifecycle.",
        },
      ],
    },
  ];

  return (
    <div className="bg-white p-6 md:p-8 font-sans">
      <div className="max-w-[1800px] mx-auto">
        {/* Main Title */}
        <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-[#183076] text-center mb-12">
          Standardized Pre-Analytical Controls
        </h2>

        {/* Responsive Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {sections.map((section, idx) => (
            <div
              key={idx}
              className="border-2 border-[#183076]/20 rounded-3xl p-4 md:p-10 bg-white shadow-sm"
            >
              <h3 className="text-[20px] md:text-[28px] 2xl:text-[40px]  font-bold text-[#183076] mb-8">
                {section.title}
              </h3>

              <div className="space-y-8">
                {section.items.map((item, itemIdx) => (
                  <div key={itemIdx} className="flex items-start gap-4">
                    {/* Icon Circle */}
                    <div className="bg-[#183076] p-2 rounded-full text-white shrink-0">
                      {item.icon}
                    </div>

                    {/* Text Content */}
                    <div>
                      <h4 className="text-[20px] md:text-[24px] 2xl:text-[30px] font-bold text-[#183076]">
                        {item.label}
                      </h4>
                      <p className=" text-[14px] md:text-[18px] xl:text-[24px] leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreAnalyticalControls;
